import type { ApiRoute, NoBody, NoQueryParams } from "../../api"
import type { HeaderView } from "./HeaderView"

export interface GetVehicleDetailsPathParams {
	inventoryId: string
}

export const getVehicleDetailsHeaderRoute: ApiRoute<GetVehicleDetailsPathParams, NoQueryParams, NoBody, HeaderView> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/header`,
	method: "get",
	path: "/vehicles/:inventoryId/header",
}
